module.exports = __webpack_public_path__ + "img/dj.0ca45152.gif";